
import * as React from 'react';
import { Facet } from '../../../models/Facet';
import { ShowProgressAction } from '../../actions/showProgress/ShowProgressAction';
import { ICommandBarItemProps } from '@uifabric/experiments/lib/CommandBar';
import { ProgressCommandButton } from '../../progress/commandButton/ProgressCommandButton';
import { ICommand, ICommandStateProps } from '../../../models/commands/ICommand';
import { commandBarItemDefaultRender } from '../commandBarItemDefaultRender';
import CommandStrings from '../Commands.resx';
import KeyboardMapStrings from '../../keyboard/KeyboardMap.resx';

/**
 * Command which automatically appears to report progress for background tasks.
 */
export const showProgressCommand: ICommand = {
    key: new Facet('progress').id,
    automationId: 'showProgressCommand',
    action: <ShowProgressAction />,
    keytipProps: {
        keySequences: ['G'],
        content: KeyboardMapStrings.showActionDetailsDesc
    },
    ariaLabel: CommandStrings.ShowProgressCommandAriaLabel,
    onRender: (item: ICommandBarItemProps & ICommandStateProps): JSX.Element => {
        const {
            actionState
        } = item;

        return (
            <ProgressCommandButton
                item={ item }
                isExecuting={ !!actionState && actionState.executingCount > 0 }
                defaultRender={ commandBarItemDefaultRender }
            />
        );
    }
};
